import * as React from 'react';
import { CheckboxList } from 'ui';
import { ComplexValue } from 'app/types-shared';
import { FilterCommonProps, FilterCommonValues } from './types';
import { MeatballPanel } from 'app/area/search-filters/filters/meatball-panel';

export class FilterExternalValueCheckbox extends React.PureComponent<FilterCommonProps<number>> {

  private onChange = (values: FilterCommonValues<number>[]) => {
    this.props.onChange(this.props.id, values);
  };

  public render() {

    const { id, values, options, meatballPanelConfiguration, translation } = this.props;

    return <>
      <MeatballPanel configuration={meatballPanelConfiguration} />
      <div className="form-check mb-1">
        <b className="pl-2">{translation.filters_contains_word}</b>
        <CheckboxList
          className={'mt-2'}
          componentId={id}
          valueItems={(values || []) as ComplexValue<number>[]}
          options={options as ComplexValue<number>[]}
          onChange={this.onChange}
        />
      </div>
    </>;
  }
}
